<div fxLayout="row" fxLayoutAlign="space-around start" fxLayoutGap="1em" class="select-list-div">
  <app-select-with-delete-option #setOfFiltersList [loadingFilters]="loadingFilters" [groupedValues]="groupedSetOfFilters" [valuesDescription]="this.setsOfFilters?.length ? 'existingSetsOfFilters' : 'noSetsOfFilters'"
    (valueSelected)="onSetOfFiltersSelected($event)" (valueDeleted)="deleteSetOfFilters($event)">
  </app-select-with-delete-option>

  <div>
    <button mat-icon-button color="sims" *ngIf="isSaveButtonEnabled()" (click)="saveSetOfFilters()" [matTooltip]="(mode + 'SetOfFilters') | translate" class="mt-2">
      <mat-icon svgIcon="{{ mode == saveModeHelper.COPY ? 'content_copy' : 'save' }}"></mat-icon>
    </button>

    <button mat-icon-button color="sims" (click)="resetFilters()" [matTooltip]="'resetFilters' | translate" class="mt-2">
      <mat-icon svgIcon="cancel"></mat-icon>
    </button>
  </div>

</div>